<template>
  <mdb-footer color="heavy-rain-gradient">
    <p class="footer-copyright mb-0 py-2 pr-2 text-right text-white">
      &copy; {{new Date().getFullYear()}} TRADECOM Digital Solutions GmbH
    </p>
  </mdb-footer>
</template>

<script>
import { mdbFooter } from 'mdbvue'

export default {
  name: 'Footer',
  components: {
    mdbFooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer p{
  font-size: 14px;
}
</style>
